// ¿Hay suficiente escrito para buscar un socio?
//
// Reporte del cliente (CRUO, 18-ago-2026): en la Sala, teclear "1" no encontraba al
// socio nº 1 — había que escribir "01". El motivo no era el número: era que la
// pantalla exigía 2 caracteres antes de llamar al backend, así que un solo dígito ni
// llegaba a buscarse. Con "01" ya eran dos, y el backend normaliza los ceros a la
// izquierda (`int("01")` → 1), de ahí el apaño que habían descubierto.
//
// Por qué un dígito SÍ y una letra NO: la búsqueda numérica del backend es EXACTA
// sobre el nº visible del socio (`legacy_member_id`, o `membership_id` si no lo
// tiene), así que "1" devuelve al socio 1 y punto — precisa y barata. Una letra
// suelta, en cambio, es un `%a%` contra nombre y email: ruido a mansalva y una
// llamada por tecla que no ayuda a nadie.
const SOLO_DIGITOS = /^\d+$/;

export function minimoBusqueda(termino) {
	return SOLO_DIGITOS.test(String(termino ?? '').trim()) ? 1 : 2;
}

export function busquedaSuficiente(termino) {
	const t = String(termino ?? '').trim();
	return t.length >= minimoBusqueda(t);
}

// ¿Este socio casa con lo que se ha tecleado en un buscador local?
//
// Reporte (staging, 13-oct-2026): en la Sala, «Leo » encontraba a «Leo NUevo» y
// «Leo N» no. La ficha tenía el nombre guardado con un espacio al final («Leo »), así
// que «nombre + ' ' + apellido» daba «leo  nuevo» con DOS espacios — y el HTML los
// pinta como uno, de modo que en pantalla no había nada raro que ver. Cada pantalla
// tenía su propio `fullName.includes(q)`, y todas fallaban igual.
//
// Regla única: se normalizan los dos lados (minúsculas, sin tildes, cualquier racha
// de espacios — incluidos los no separables — vale por uno) y CADA palabra tecleada
// tiene que aparecer en alguno de los campos. Así «Leo N», «nuevo leo» y «jose» para
// «José» encuentran lo que el ojo espera.
function normalizarBusqueda(texto) {
	return String(texto ?? '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.replace(/\s+/g, ' ')
		.trim();
}

// Devuelve el predicado `(campos) => bool` con el término ya normalizado: un filtro
// recorre cientos de socios por tecla y el término no cambia entre uno y otro.
export function filtroBusqueda(termino) {
	const palabras = normalizarBusqueda(termino).split(' ').filter(Boolean);
	if (!palabras.length) return () => true;
	return (campos) => {
		const pajar = (campos || []).map(normalizarBusqueda).filter(Boolean).join(' ');
		return palabras.every((p) => pajar.includes(p));
	};
}

export function coincideBusqueda(termino, campos) {
	return filtroBusqueda(termino)(campos);
}
